var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("table", { staticClass: "table bg-white table-bordered" }, [
    _c("thead", { staticClass: "thead-light" }, [
      _c("tr", [
        _c("th", { staticClass: "font-weight-bold" }, [
          _c("h6", [_vm._v(" " + _vm._s(_vm._f("trans")("Name")))]),
        ]),
        _vm._v(" "),
        _c("th", { staticClass: "font-weight-bold" }, [
          _c("h6", [_vm._v(" " + _vm._s(_vm._f("trans")("Harmonic Mean")))]),
        ]),
        _vm._v(" "),
        _c("th", { staticClass: "font-weight-bold" }, [
          _c("h6", [_vm._v(" " + _vm._s(_vm._f("trans")("Mean")))]),
        ]),
        _vm._v(" "),
        _c("th", { staticClass: "font-weight-bold" }, [
          _c("h6", [_vm._v(" " + _vm._s(_vm._f("trans")("Max")))]),
        ]),
        _vm._v(" "),
        _c("th", { staticClass: "font-weight-bold" }, [
          _c("h6", [_vm._v(" " + _vm._s(_vm._f("trans")("Min")))]),
        ]),
      ]),
    ]),
    _vm._v(" "),
    _c("tbody", [
      _c("tr", [
        _c("td", [
          _c(
            "span",
            [
              _vm._v("Integer Adm2\n                                 "),
              _c("Tooltip", {
                attrs: { position: "right" },
                scopedSlots: _vm._u([
                  {
                    key: "icon",
                    fn: function () {
                      return [
                        _c("i", {
                          staticClass:
                            "far fa-info-circle text-info text-info cursor-pointer",
                        }),
                      ]
                    },
                    proxy: true,
                  },
                  {
                    key: "tooltip-content",
                    fn: function () {
                      return [_vm._v(" " + _vm._s(_vm.integerAdm2Text))]
                    },
                    proxy: true,
                  },
                ]),
              }),
            ],
            1
          ),
        ]),
        _vm._v(" "),
        _c("td", [
          _c("span", [
            _vm._v(
              _vm._s(this.pooledMetrics.integer_adm2.harmonic_mean) +
                "\n                             "
            ),
          ]),
        ]),
        _vm._v(" "),
        _c("td", [
          _c("span", [
            _vm._v(
              _vm._s(this.pooledMetrics.integer_adm2.mean) +
                "\n                             "
            ),
          ]),
        ]),
        _vm._v(" "),
        _c("td", [
          _c("span", [_vm._v(_vm._s(this.pooledMetrics.integer_adm2.max))]),
        ]),
        _vm._v(" "),
        _c("td", [
          _c("span", [_vm._v(_vm._s(this.pooledMetrics.integer_adm2.min))]),
        ]),
      ]),
      _vm._v(" "),
      _c("tr", [
        _c("td", [
          _c(
            "span",
            [
              _vm._v("Integer Adm Scale 0\n                                 "),
              _c("Tooltip", {
                attrs: { position: "right" },
                scopedSlots: _vm._u([
                  {
                    key: "icon",
                    fn: function () {
                      return [
                        _c("i", {
                          staticClass:
                            "far fa-info-circle text-info text-info cursor-pointer",
                        }),
                      ]
                    },
                    proxy: true,
                  },
                  {
                    key: "tooltip-content",
                    fn: function () {
                      return [_vm._v(" " + _vm._s(_vm.integerAdmScaleText))]
                    },
                    proxy: true,
                  },
                ]),
              }),
            ],
            1
          ),
        ]),
        _vm._v(" "),
        _c("td", [
          _c("span", [
            _vm._v(_vm._s(this.pooledMetrics.integer_adm_scale0.harmonic_mean)),
          ]),
        ]),
        _vm._v(" "),
        _c("td", [
          _c("span", [
            _vm._v(_vm._s(this.pooledMetrics.integer_adm_scale0.mean)),
          ]),
        ]),
        _vm._v(" "),
        _c("td", [
          _c("span", [
            _vm._v(_vm._s(this.pooledMetrics.integer_adm_scale0.max)),
          ]),
        ]),
        _vm._v(" "),
        _c("td", [
          _c("span", [
            _vm._v(_vm._s(this.pooledMetrics.integer_adm_scale0.min)),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _c("tr", [
        _vm._m(0),
        _vm._v(" "),
        _c("td", [
          _c("span", [
            _vm._v(_vm._s(this.pooledMetrics.integer_adm_scale1.harmonic_mean)),
          ]),
        ]),
        _vm._v(" "),
        _c("td", [
          _c("span", [
            _vm._v(_vm._s(this.pooledMetrics.integer_adm_scale1.mean)),
          ]),
        ]),
        _vm._v(" "),
        _c("td", [
          _c("span", [
            _vm._v(_vm._s(this.pooledMetrics.integer_adm_scale1.max)),
          ]),
        ]),
        _vm._v(" "),
        _c("td", [
          _c("span", [
            _vm._v(_vm._s(this.pooledMetrics.integer_adm_scale1.min)),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _c("tr", [
        _vm._m(1),
        _vm._v(" "),
        _c("td", [
          _c("span", [
            _vm._v(_vm._s(this.pooledMetrics.integer_adm_scale2.harmonic_mean)),
          ]),
        ]),
        _vm._v(" "),
        _c("td", [
          _c("span", [
            _vm._v(_vm._s(this.pooledMetrics.integer_adm_scale2.mean)),
          ]),
        ]),
        _vm._v(" "),
        _c("td", [
          _c("span", [
            _vm._v(_vm._s(this.pooledMetrics.integer_adm_scale2.max)),
          ]),
        ]),
        _vm._v(" "),
        _c("td", [
          _c("span", [
            _vm._v(_vm._s(this.pooledMetrics.integer_adm_scale2.min)),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _c("tr", [
        _vm._m(2),
        _vm._v(" "),
        _c("td", [
          _c("span", [
            _vm._v(_vm._s(this.pooledMetrics.integer_adm_scale3.harmonic_mean)),
          ]),
        ]),
        _vm._v(" "),
        _c("td", [
          _c("span", [
            _vm._v(_vm._s(this.pooledMetrics.integer_adm_scale3.mean)),
          ]),
        ]),
        _vm._v(" "),
        _c("td", [
          _c("span", [
            _vm._v(_vm._s(this.pooledMetrics.integer_adm_scale3.max)),
          ]),
        ]),
        _vm._v(" "),
        _c("td", [
          _c("span", [
            _vm._v(_vm._s(this.pooledMetrics.integer_adm_scale3.min)),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _c("tr", [
        _c("td", [
          _c(
            "span",
            [
              _vm._v("Integer Motion\n                                 "),
              _c("Tooltip", {
                attrs: { position: "right" },
                scopedSlots: _vm._u([
                  {
                    key: "icon",
                    fn: function () {
                      return [
                        _c("i", {
                          staticClass:
                            "far fa-info-circle text-info text-info cursor-pointer",
                        }),
                      ]
                    },
                    proxy: true,
                  },
                  {
                    key: "tooltip-content",
                    fn: function () {
                      return [_vm._v(" " + _vm._s(_vm.integerMotionText))]
                    },
                    proxy: true,
                  },
                ]),
              }),
            ],
            1
          ),
        ]),
        _vm._v(" "),
        _c("td", [
          _c("span", [
            _vm._v(_vm._s(this.pooledMetrics.integer_motion.harmonic_mean)),
          ]),
        ]),
        _vm._v(" "),
        _c("td", [
          _c("span", [_vm._v(_vm._s(this.pooledMetrics.integer_motion.mean))]),
        ]),
        _vm._v(" "),
        _c("td", [
          _c("span", [_vm._v(_vm._s(this.pooledMetrics.integer_motion.max))]),
        ]),
        _vm._v(" "),
        _c("td", [
          _c("span", [_vm._v(_vm._s(this.pooledMetrics.integer_motion.min))]),
        ]),
      ]),
      _vm._v(" "),
      _c("tr", [
        _vm._m(3),
        _vm._v(" "),
        _c("td", [
          _c("span", [
            _vm._v(_vm._s(this.pooledMetrics.integer_motion2.harmonic_mean)),
          ]),
        ]),
        _vm._v(" "),
        _c("td", [
          _c("span", [_vm._v(_vm._s(this.pooledMetrics.integer_motion2.mean))]),
        ]),
        _vm._v(" "),
        _c("td", [
          _c("span", [_vm._v(_vm._s(this.pooledMetrics.integer_motion2.max))]),
        ]),
        _vm._v(" "),
        _c("td", [
          _c("span", [_vm._v(_vm._s(this.pooledMetrics.integer_motion2.min))]),
        ]),
      ]),
      _vm._v(" "),
      _c("tr", [
        _c("td", [
          _c(
            "span",
            [
              _vm._v("Integer Vif Scale 0\n                                 "),
              _c("Tooltip", {
                attrs: { position: "right" },
                scopedSlots: _vm._u([
                  {
                    key: "icon",
                    fn: function () {
                      return [
                        _c("i", {
                          staticClass:
                            "far fa-info-circle text-info text-info cursor-pointer",
                        }),
                      ]
                    },
                    proxy: true,
                  },
                  {
                    key: "tooltip-content",
                    fn: function () {
                      return [_vm._v(" " + _vm._s(_vm.integerVifScaleText))]
                    },
                    proxy: true,
                  },
                ]),
              }),
            ],
            1
          ),
        ]),
        _vm._v(" "),
        _c("td", [
          _c("span", [
            _vm._v(_vm._s(this.pooledMetrics.integer_vif_scale0.harmonic_mean)),
          ]),
        ]),
        _vm._v(" "),
        _c("td", [
          _c("span", [
            _vm._v(_vm._s(this.pooledMetrics.integer_vif_scale0.mean)),
          ]),
        ]),
        _vm._v(" "),
        _c("td", [
          _c("span", [
            _vm._v(_vm._s(this.pooledMetrics.integer_vif_scale0.max)),
          ]),
        ]),
        _vm._v(" "),
        _c("td", [
          _c("span", [
            _vm._v(_vm._s(this.pooledMetrics.integer_vif_scale0.min)),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _c("tr", [
        _vm._m(4),
        _vm._v(" "),
        _c("td", [
          _c("span", [
            _vm._v(_vm._s(this.pooledMetrics.integer_vif_scale1.harmonic_mean)),
          ]),
        ]),
        _vm._v(" "),
        _c("td", [
          _c("span", [
            _vm._v(_vm._s(this.pooledMetrics.integer_vif_scale1.mean)),
          ]),
        ]),
        _vm._v(" "),
        _c("td", [
          _c("span", [
            _vm._v(_vm._s(this.pooledMetrics.integer_vif_scale1.max)),
          ]),
        ]),
        _vm._v(" "),
        _c("td", [
          _c("span", [
            _vm._v(_vm._s(this.pooledMetrics.integer_vif_scale1.min)),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _c("tr", [
        _vm._m(5),
        _vm._v(" "),
        _c("td", [
          _c("span", [
            _vm._v(_vm._s(this.pooledMetrics.integer_vif_scale2.harmonic_mean)),
          ]),
        ]),
        _vm._v(" "),
        _c("td", [
          _c("span", [
            _vm._v(_vm._s(this.pooledMetrics.integer_vif_scale2.mean)),
          ]),
        ]),
        _vm._v(" "),
        _c("td", [
          _c("span", [
            _vm._v(_vm._s(this.pooledMetrics.integer_vif_scale2.max)),
          ]),
        ]),
        _vm._v(" "),
        _c("td", [
          _c("span", [
            _vm._v(_vm._s(this.pooledMetrics.integer_vif_scale2.min)),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _c("tr", [
        _vm._m(6),
        _vm._v(" "),
        _c("td", [
          _c("span", [
            _vm._v(_vm._s(this.pooledMetrics.integer_vif_scale3.harmonic_mean)),
          ]),
        ]),
        _vm._v(" "),
        _c("td", [
          _c("span", [
            _vm._v(_vm._s(this.pooledMetrics.integer_vif_scale3.mean)),
          ]),
        ]),
        _vm._v(" "),
        _c("td", [
          _c("span", [
            _vm._v(_vm._s(this.pooledMetrics.integer_vif_scale3.max)),
          ]),
        ]),
        _vm._v(" "),
        _c("td", [
          _c("span", [
            _vm._v(_vm._s(this.pooledMetrics.integer_vif_scale3.min)),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _c("tr", [
        _c("td", [
          _c(
            "span",
            [
              _vm._v("Vmaf\n                                 "),
              _c("Tooltip", {
                attrs: { position: "right" },
                scopedSlots: _vm._u([
                  {
                    key: "icon",
                    fn: function () {
                      return [
                        _c("i", {
                          staticClass:
                            "far fa-info-circle text-info text-info cursor-pointer",
                        }),
                      ]
                    },
                    proxy: true,
                  },
                  {
                    key: "tooltip-content",
                    fn: function () {
                      return [_vm._v(" " + _vm._s(_vm.vmafText))]
                    },
                    proxy: true,
                  },
                ]),
              }),
            ],
            1
          ),
        ]),
        _vm._v(" "),
        _c("td", [
          _c("span", [_vm._v(_vm._s(this.pooledMetrics.vmaf.harmonic_mean))]),
        ]),
        _vm._v(" "),
        _c("td", [_c("span", [_vm._v(_vm._s(this.pooledMetrics.vmaf.mean))])]),
        _vm._v(" "),
        _c("td", [_c("span", [_vm._v(_vm._s(this.pooledMetrics.vmaf.max))])]),
        _vm._v(" "),
        _c("td", [_c("span", [_vm._v(_vm._s(this.pooledMetrics.vmaf.min))])]),
      ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("td", [
      _c("span", [
        _vm._v("Integer Adm Scale 1\n                                 "),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("td", [
      _c("span", [
        _vm._v("Integer Adm Scale 2\n                                 "),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("td", [
      _c("span", [
        _vm._v("Integer Adm Scale 3\n                                 "),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("td", [
      _c("span", [
        _vm._v("Integer Motion 2\n                                 "),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("td", [
      _c("span", [
        _vm._v("Integer Vif Scale 1\n                                 "),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("td", [
      _c("span", [
        _vm._v("Integer Vif Scale 2\n                                 "),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("td", [
      _c("span", [
        _vm._v("Integer Vif Scale 3\n                                 "),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }